<template>
  <div class="row">

    <div class="col-xl-1 col-lg-2 col-md-3">
    </div>
    <div class="col-xl-10 col-lg-8 col-md-6">
      <create-mundial-form>

      </create-mundial-form>
    </div>
    <div class="col-xl-1 col-lg-2 col-md-3">
    </div>

  </div>
</template>
<script>
  import CreateMundialForm from './UserProfile/CreateMundialForm.vue'
  import UserCard from './UserProfile/UserCard.vue'
  import MembersCard from './UserProfile/MembersCard.vue'

  export default {
    components: {
      CreateMundialForm,
      UserCard,
      MembersCard
    }
  }

</script>
<style>

</style>
